export const transformDateString = (dateString: string): string => {
  const date = new Date(dateString);
  const month = date.toLocaleString('default', { month: 'long' });
  const day = date.getUTCDate().toString();
  const year = date.getUTCFullYear().toString();
  return `${month} ${day}, ${year}`;
};
